import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useRef, useState } from "react";
import { env } from "build/env";
import { grantCustomerConsents, readCustomerToken } from "./consentApi";

/** Retry only the consent write, never the already-completed registration or booking. */
export const useConsentCapture = function () {
  let {
    requireParticipation = false
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const pending = useRef(null);
  const saving = useRef(false);
  const [consentSaveFailed, setConsentSaveFailed] = useState(false);
  const [isSavingConsents, setIsSavingConsents] = useState(false);
  const retryConsents = async () => {
    if (!pending.current || saving.current) return;
    saving.current = true;
    setIsSavingConsents(true);
    const capture = pending.current;
    let saved = false;
    try {
      await grantCustomerConsents({
        baseUrl: env.API_SERVER_URL,
        consents: capture.consents,
        // Pin the original identity so switching accounts cannot redirect a retry.
        storage: {
          getItem: name => name === "signin_token" ? capture.token : null
        }
      });
      pending.current = null;
      setConsentSaveFailed(false);
      saved = true;
    } catch (error) {
      setConsentSaveFailed(true);
    } finally {
      saving.current = false;
      setIsSavingConsents(false);
    }
    if (saved) capture.onComplete();
  };
  const captureConsents = async _ref => {
    let {
      consents,
      onComplete
    } = _ref;
    if (pending.current || saving.current) return;
    pending.current = {
      consents: _objectSpread({}, consents),
      token: readCustomerToken(),
      onComplete
    };
    await retryConsents();
  };
  const continueWithoutConsents = () => {
    if (requireParticipation || saving.current || !pending.current) return;
    const {
      onComplete
    } = pending.current;
    pending.current = null;
    setConsentSaveFailed(false);
    onComplete();
  };
  return {
    captureConsents,
    consentSaveFailed,
    isSavingConsents,
    retryConsents,
    continueWithoutConsents,
    canContinueWithoutConsents: !requireParticipation
  };
};